import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useCookies } from 'react-cookie'
import { AFFILIATE_COOKIE, isValidAffiliate } from '../utils/affiliate'

// Captures ?aff=CODE from any route into a 60 minute cookie so purchases made
// within that window can be attributed to the affiliate. Anonymous users included.
export default function AffiliateTracker() {
  const location = useLocation()
  const [, setCookie] = useCookies([AFFILIATE_COOKIE])

  useEffect(() => {
    const aff = new URLSearchParams(location.search).get('aff')
    if (aff && isValidAffiliate(aff)) {
      setCookie(AFFILIATE_COOKIE, aff, { path: '/', maxAge: 3600, secure: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search])

  return null
}
